// addToCart
const addToCart = document.querySelectorAll('.add_cart_btn');

  for(let i = 0; i < addToCart.length; i++){ // ②
    addToCart[i].addEventListener('click', () => {
      
      let addToCartForm = document.querySelector('form[action$="/cart/add"]');
      let formData = new FormData(addToCartForm);
      console.log(addToCartForm);
      console.log(formData);


        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
            modalOpen();
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });
  };

let modalOpen = () => {
    $('#modalArea').fadeIn();
}

$('#closeModal1 , #modalBg , #closeModal2').click(function(){
    $('#modalArea').fadeOut();
});

// ページシェア
let productUrl = location.href
let productSnsLinks=$(".js-sns-link")
for(let i=0; i<productSnsLinks.length; i++){
    let href=productSnsLinks.eq(i).attr('href');
    //シェアページのURL上書き
    href=href.replace("u=","u="+productUrl)     //facebook
    href=href.replace("url=","url="+productUrl) //twitter,LINE,はてなブログ,ピンタレスト
    productSnsLinks.eq(i).attr('href',href);
}

// スクロールイベント
window.addEventListener('scroll', debounce(scrollProcess, 50));

function debounce(fn, interval) {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn();
    }, interval);
  }
}

function scrollProcess() {
  const pageYOffset = this.pageYOffset;
  changeBtnClass(pageYOffset);
}

function changeBtnClass(pageYOffset) {
  const numberSelector1 = document.querySelector('#number-selector1');
  const numberSelector2 = document.querySelector('#number-selector2');
  if (!numberSelector2) return;
  const itemNumber = document.querySelector('#add_item_num');
  const element = document.querySelector('#number-selector1');
  const rect = numberSelector1.getBoundingClientRect();
  const top = rect.top + pageYOffset;
  if (pageYOffset > top) {
      numberSelector2.after(itemNumber);
  } else {
      numberSelector1.after(itemNumber);
  }
}

//カスタムエレメント
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    let options = this.options;
    let messageTitle = document.querySelector(".degital_order_app_message_dt");
    let messageBody = document.querySelector(".degital_order_app_message_dd");
    let messageCaption = document.querySelector(".degital_order_app_message_caption");
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  getSelectedOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    let options = this.options;
    let panel = document.querySelector(".panel.is-show");
    let messageTitle = document.querySelector(".degital_order_app_message_dt");
    let messageBody = document.querySelector(".degital_order_app_message_dd");
    let messageCaption = document.querySelector(".degital_order_app_message_caption");
    panel.classList.remove('is-show');
    panel.firstElementChild.removeAttribute("name");
    let tab;
    for(let i = 0; i < options.length; i++) {
        if (options[i].indexOf('__11') !== -1) {
            tab = document.querySelector(".tab-11");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__12') !== -1 ) {
            tab = document.querySelector(".tab-12");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__13') !== -1 ) {
            tab = document.querySelector(".tab-13");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__14') !== -1 ) {
            tab = document.querySelector(".tab-14");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__15') !== -1 ) {
            tab = document.querySelector(".tab-15");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__16') !== -1 ) {
            tab = document.querySelector(".tab-16");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__21') !== -1 ) {
            tab = document.querySelector(".tab-21");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__22') !== -1 ) {
            tab = document.querySelector(".tab-22");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__23') !== -1 ) {
            tab = document.querySelector(".tab-23");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__24') !== -1 ) {
            tab = document.querySelector(".tab-24");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__25') !== -1 ) {
            tab = document.querySelector(".tab-25");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__26') !== -1 ) {
            tab = document.querySelector(".tab-26");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__27') !== -1 ) {
            tab = document.querySelector(".tab-27");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else if (options[i].indexOf('__2') !== -1) {
            tab = document.querySelector(".tab-2");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        } else {
            tab = document.querySelector(".tab-1");
            tab.classList.add('is-show');
            tab.firstElementChild.setAttribute("name","properties[お受け取り希望時間]");
        }
      }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const now = Date.now();
    //販売期間のメタフィールド値をdata属性から取得する
    let startTimeData = addButton.dataset.start;
    let startTime = new Date(startTimeData).getTime();
    let endtTimeData = addButton.dataset.end;
    let endTime = new Date(endtTimeData).getTime();

    // 片方のメタフィールドのみ空の場合は、現在時刻を代入する
    if (!startTime) {
      startTime = now;
    }
    if (!endTime) {
      endTime = now;
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (startTime <= now && now <= endTime) {
        console.log('売り切れ');
      } else {
        addButtonText.textContent = '販売期間外';
        console.log('販売期間外。');
      }
    } else {
      if (startTime <= now && now <= endTime) {
        console.log('販売可能です。');
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      } else {
        addButtonText.textContent = '販売期間外';
        console.log('販売期間外。');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
            console.log(price);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);